import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppService } from './app/services/app.service';

if (environment.production) {
  enableProdMode();
  window.console.log = () => { };
  window.console.debug = () => { };
  window.console.info = () => { };
  window.console.warn = () => { }
}

function getIOSVersion(): number | null {
  const userAgent = navigator.userAgent;
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  if (!isIOS) return null;

  const match = userAgent.match(/OS (\d+)_(\d+)/);
  return match ? parseInt(match[1], 10) : null;
}

function isIOSVersionSupported(): boolean {
  const iosVersion = getIOSVersion();
  if (iosVersion === null) return true;
  return iosVersion >= 17;
}

function getTabId(): string {
  // const fullUrl = window.location.href;
  const fullUrl = AppService.getAppUrl();
  const questionMarkIndex = fullUrl.indexOf('?');
  const rawParam = questionMarkIndex !== -1
    ? fullUrl.substring(questionMarkIndex + 1).replace(/=+$/, '')
    : '';
  console.log("rawParam", rawParam)
  const urlParams = new URLSearchParams(rawParam);
  // After navigation — taskId in URL (?taskId=DETSKED10000)
  const urlTaskId = urlParams.get('taskId');
  console.log("urlTaskId", urlTaskId)
  if (urlTaskId) {
    sessionStorage.setItem('tabId', urlTaskId);
    return urlTaskId;
  }

  // App start — hashKey in URL (?96E57)
  const urlHashKey = rawParam.length >= 5 && rawParam.length <= 8 && !rawParam.includes('=')
    ? rawParam
    : null;

  if (urlHashKey) {
    const storedTabId = sessionStorage.getItem('tabId');
    if (!storedTabId) {
      const restoredTaskId = restoreSessionFromCookie(urlHashKey);
      if (restoredTaskId) {
        sessionStorage.setItem('tabId', restoredTaskId);
        return restoredTaskId;
      }

      sessionStorage.setItem('tabId', urlHashKey);
    }
    return sessionStorage.getItem('tabId') || urlHashKey;
  }

  // After router navigation — no params in URL, use stored
  return sessionStorage.getItem('tabId') || '';
}

function restoreSessionFromCookie(hashKey?: string): string | null {
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();

    if (c.startsWith('authToken_')) {
      try {
        const raw = c.substring(c.indexOf('=') + 1);
        const parsed = JSON.parse(decodeURIComponent(raw));

        if (hashKey && parsed.query !== hashKey) continue;

        const taskId = parsed.taskId;
        console.log("taskId main", taskId)
        if (taskId) {
          sessionStorage.setItem('tabId', taskId);
          console.log('Session restored — taskId:', taskId);
          return taskId;
        }

      } catch (e) {
        console.error('Restore failed:', e);
      }
    }
  }

  return null;
}


if (!isIOSVersionSupported()) {
  document.body.innerHTML = `
  <div style="display:flex;align-items:center;justify-content:center;min-height:100vh;background:#f2f2f7;padding:20px;font-family:-apple-system,BlinkMacSystemFont,'SF Pro Text','SF Pro Display',sans-serif;">
    <div style="width:100%;max-width:320px;">

      <div style="text-align:center;margin-bottom:20px;padding:0 10px;">
        <h2 style="font-size:20px;font-weight:700;margin:0 0 8px;color:#000;letter-spacing:-0.3px;">Update Required</h2>
        <p style="font-size:14px;color:#3c3c43;margin:0;line-height:1.5;font-weight:400;opacity:0.6;">This application requires iOS 17 or later to function properly</p>
      </div>

      <div style="display:flex;justify-content:center;margin-bottom:24px;padding:16px 0;">
        <div style="position:relative;width:130px;height:155px;">
          
          <!-- Phone body — filled gray -->
          <div style="width:130px;height:155px;background:#e5e5ea;border-radius:24px;position:absolute;top:0;left:0;"></div>

          <!-- Inner screen area -->
          <div style="width:108px;height:130px;background:#f2f2f7;border-radius:16px;position:absolute;top:12px;left:11px;display:flex;align-items:center;justify-content:center;">
            
            <!-- Warning circle -->
            <div style="width:52px;height:52px;border-radius:50%;border:2px solid #c7c7cc;display:flex;align-items:center;justify-content:center;background:#f2f2f7;">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#c7c7cc" stroke-width="1.8"><path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/></svg>
            </div>
          </div>

          <!-- Top notch bar -->
          <div style="width:36px;height:5px;background:#c7c7cc;border-radius:3px;position:absolute;top:6px;left:50%;transform:translateX(-50%);z-index:1;"></div>

          <!-- Bottom home indicator -->
          <div style="width:14px;height:14px;border-radius:50%;background:#c7c7cc;position:absolute;bottom:6px;left:50%;transform:translateX(-50%);"></div>

        </div>
      </div>

      <div style="display:flex;flex-direction:column;gap:2px;margin-bottom:24px;background:#fff;border-radius:12px;overflow:hidden;">
        
        <div style="display:flex;align-items:flex-start;gap:14px;padding:14px 16px;">
          <div style="width:32px;height:32px;border-radius:50%;border:1.5px solid #d1d1d6;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:1px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8e8e93" stroke-width="1.8"><path d="M23 4v6h-6M1 20v-6h6"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/></svg>
          </div>
          <div style="flex:1;">
            <p style="font-size:15px;font-weight:600;margin:0 0 3px;color:#000;letter-spacing:-0.1px;">Update Your iOS</p>
            <p style="font-size:13px;color:#3c3c43;margin:0;line-height:1.5;opacity:0.6;">Go to Settings → General → Software Update to install the latest iOS version</p>
          </div>
        </div>

        <div style="height:0.5px;background:#d1d1d6;margin:0 16px;"></div>

        <div style="display:flex;align-items:flex-start;gap:14px;padding:14px 16px;">
          <div style="width:32px;height:32px;border-radius:50%;border:1.5px solid #d1d1d6;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:1px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8e8e93" stroke-width="1.8"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>
          </div>
          <div style="flex:1;">
            <p style="font-size:15px;font-weight:600;margin:0 0 3px;color:#000;letter-spacing:-0.1px;">Use Another Device</p>
            <p style="font-size:13px;color:#3c3c43;margin:0;line-height:1.5;opacity:0.6;">Access this application on a device running iOS 17 or later</p>
          </div>
        </div>

      </div>

      <div style="text-align:center;">
        <p style="font-size:12px;color:#3c3c43;margin:0 0 5px;opacity:0.4;">Minimum requirement: iOS 17.0 or later</p>
        <p style="font-size:12px;color:#3c3c43;margin:0;opacity:0.4;">For assistance, please <a href="mailto:support@digitaleyes.app" style="color:#007aff;text-decoration:none;opacity:1;">contact support</a></p>
      </div>

    </div>
  </div>
`;
} else {
  getTabId();
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
}
// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.log(err));
